const QUERIES = {
  USERS_LIST: 'users-list',
  ROLES_LIST: 'roles-list',
  CLINIC_DELETE:'delete-clinic'
}

export {QUERIES}
